const generateTryoutRoutes = () => {
  const activeTryout = process.env.VUE_APP_ACTIVE_TRYOUT?.split(",") || [];

  return activeTryout.map((tryout) => ({
    path: `/tryout/${tryout}`,
    name: `tryout-${tryout}`,
    meta: {
      pageTitle: "Tryout",
      breadcrumb: [
        {
          text: `Tryout ${
            tryout === "tka" ? "TKA SMA/MA/SMK" : tryout.toUpperCase()
          }`,
          active: true,
        },
      ],
    },
    component: () => import("@/views/menu/try-out/"),
  }));
};

export default [
  ...generateTryoutRoutes(),

  // Halaman Hasil
  {
    path: "/try-out/:jenis/:kategori/:id_tryout/hasil",
    name: "try-out/hasil",
    component: () => import("@/views/menu/hasil/Pembahasan.vue"),
    meta: {
      notRequiredWA: true,
    },
  },

  {
    path: "/try-out/detail/:id",
    name: "detail-paket-tryout",
    component: () => import("@/views/menu/try-out/detail/NewDetailTryout.vue"),
    meta: {
      notRequiredWA: true,
    },
  },
  {
    path: "/try-out/score/:id",
    name: "score-tryout",
    component: () => import("@/views/menu/try-out/detail/HasilTryout.vue"),
    meta: {
      notRequiredWA: true,
    },
  },
  {
    path: "/try-out/:id/:id_pengerjaan",
    name: "start-paket-tryout",
    component: () => import("@/views/menu/try-out/pengerjaan/HalamanAwalPengerjaan.vue"),
    meta: {
      notRequiredWA: true,
    },
  },
  {
    path: "/try-out/:id/:id_pengerjaan/:index_paket_kategori/:index_paket_mapel/start",
    name: "ujian-paket-tryout",
    component: () => import("@/views/menu/try-out/pengerjaan/UjianPaketTryout.vue"),
    meta: {
      notRequiredWA: true,
    },
  },

  //Selesai
  {
    path: "/try-out/selesai",
    name: "try-out/selesai",
    component: () => import("@/views/menu/try-out/finish/Finish.vue"),
    meta: {
      notRequiredWA: true,
    },
  },

  // history
  {
    path: "/history/tryout/:id_paket_tryout",
    name: "halaman-history-tryout",
    meta: {
      pageTitle: "Riwayat",
      breadcrumb: [
        {
          text: "Tryout",
          active: true,
        },
        {
          text: "Riwayat",
          active: true,
        },
      ],
      notRequiredWA: true,
    },
    component: () =>
      import("@/views/menu/try-out/history/HalamanHistoryTryout.vue"),
  },

  // Review
  {
    path: "/review/tryout/:id_pengerjaan",
    name: "halaman-awal-review-tryout",
    meta: {
      pageTitle: "Review",
      breadcrumb: [
        {
          text: "Tryout",
          active: true,
        },
        {
          text: "Review",
          active: true,
        },
      ],
      notRequiredWA: true,
    },
    component: () =>
      import("@/views/menu/try-out/review/HalamanAwalReviewTryout.vue"),
  },

  {
    path: "/review/tryout/:id_pengerjaan/:soal",
    name: "halaman-review-tryout",
    meta: {
      pageTitle: "Pembahasan",
      breadcrumb: [
        {
          text: "Tryout",
          active: true,
        },
        {
          text: "Review",
          active: true,
        },
        {
          text: "Pembahasan",
          active: true,
        },
      ],
      notRequiredWA: true,
    },
    component: () =>
      import("@/views/menu/try-out/review/HalamanReviewTryout.vue"),
  },

  // Hasil
  {
    path: "/review/tryout/hasil/:id_pengerjaan",
    name: "halaman-hasil-tryout",
    meta: {
      pageTitle: "Pembahasan",
      breadcrumb: [
        {
          text: "Tryout",
          active: true,
        },
        {
          text: "Review",
          active: true,
        },
        {
          text: "Hasil",
          active: true,
        },
      ],
      notRequiredWA: true,
    },
    component: () => import("@/views/menu/try-out/hasil/Pembahasan.vue"),
  },

  // Hasil Rasionalisasi
  {
    path: "/review/tryout/hasil/:id_pengerjaan/rasionalisasi/:id_rasionalisasi",
    name: "halaman-rasionalisasi",
    meta: {
      pageTitle: "Pembahasan",
      breadcrumb: [
        {
          text: "Tryout",
          active: true,
        },
        {
          text: "Review",
          active: true,
        },
        {
          text: "Hasil",
          active: true,
        },
      ],
      notRequiredWA: true,
    },
    component: () => import("@/views/menu/try-out/hasil/Rasionalisasi.vue"),
  },

  // Insight
  // Modify jd dinamis @Bilal
  {
    path: "/try-out/insight/:id/:id_pengerjaan",
    name: "insight",
    meta: {
      pageTitle: "Insight",
      notRequiredWA: true,
    },
    component: () => import("@/views/menu/try-out/insight/InsightTryOut.vue"),
  },
];
